<template>
  <article class="card-article--featured">
    <a :href="link | mgnlLink('url')" class="card-article__link card-article--featured__link">
      <figure v-if="image" class="card-article__figure card-article--featured__figure">
        <div class="card-article__category-icon" v-if="category && category.iconVisible">
          <i :class="`icon-${category.icon}`"></i>
        </div>

        <div class="card-article__figure-wrap card-article--featured__figure-wrap">
          <pg-image :lazy-src="image | mgnlMedia('url')" ></pg-image>
        </div>
      </figure>
      <div class="card-article__content card-article--featured__content">
        <div class="card-article__category card-article--featured__category" v-if="category">{{category.title}}</div>

        <div class="card-article--featured__content-bg"></div>

        <div class="card-article__text card-article--featured__text" v-if="title">
          <time class="card-article__date" :datetime="date">{{date}}</time>

          <h4 class="card-article__title card-article--featured__title">{{title}}</h4>
        </div>

        <i class="icon-read-more">
          <msg id="common.article-featured.readmore.aria" cssClass="show-for-sr" />
        </i>
      </div>
      <i class="card-article__icon icon-plus"></i>
    </a>
  </article>
</template>
<script>
import PgImage from "../Image/Image.vue";
import PgButton from "../Button/Button.vue";

export default {
  name: "CardArticleFeatured",

  components: {
    PgButton,
    PgImage
  },

  props:{
    title: {
      type: String,
      required: true,
      default: ""
    },
    link: {
      type: Object
    },
    image: {
      type: Object
    },
    date: {
      type: String
    },
    tag: {
      type: String, // TODO will be an array??
    },
    category: {
      type: Object
    },

  }
};
</script>